
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply/data-labeler",
      function () {
        return require("private-next-pages/apply/data-labeler.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply/data-labeler"])
      });
    }
  